import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import FormLabel from '@material-ui/core/FormLabel';
import { setRegionForValidations } from 'actions/I18nSection';
import { makeStyles } from '@material-ui/styles';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';

import SelectInput from '../../components/FormSelect/SelectInput';

const useStyles = makeStyles({
  labelHorizontal: extendedFormsStyle.labelHorizontal,
  selectInput: { padding: '0' },
});

const transformResponse = response =>
  response
    ?.map(country => ({
      ...country,
      label: country.name,
      value: country.code,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

const I18NSection = ({ setSupportedRegions, supportedRegions }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const countryInformations = useSelector(
    state => state.Brands.countryInformations
  );

  if (!countryInformations) {
    return null;
  }

  const countries = transformResponse(countryInformations);
  const supportedRegion = supportedRegions?.[0];

  const getCountryForValidation = countryCode =>
    countries?.find(({ code }) => code === countryCode);

  return (
    <div>
      <FormLabel className={classes.labelHorizontal}>
        {t('brandCfg.postCodeFormat')}
      </FormLabel>
      <SelectInput
        className={classes.selectInput}
        noGrid={true}
        mapBy="label"
        trackBy="value"
        value={supportedRegion}
        options={countries}
        handleChange={e => {
          setSupportedRegions(e.target.value);
          dispatch(
            setRegionForValidations(getCountryForValidation(e.target.value))
          );
        }}
      />
    </div>
  );
};

export default I18NSection;
